import { useEffect } from 'react';

import { useFeatureFlagStore } from '@moniebook-web/store';

import { APP_BACKGROUND_JOBS } from '../constants';
import { useBusinessStore } from '../store';
import { FEATURE_FLAGS } from '../types';
import { backgroundJob } from './background-job';
import { itemStockSyncJobHandler } from './item-stock';
import { logRegisterInfoJobHandler } from './register-info';
import { fetchCartsJobHandlerV2 } from './remote-cart/fetch';
import { syncPendingCartJobHandlerV2 } from './remote-cart/sync';
import { savedCartJobHandler } from './saved-cart';
import { subscriptionJobHandler } from './subscription';
import { unsyncedSalesJobHandler } from './unsynced-sales';

const TIME_INTERVAL_WHEN_STOCK_FALLBACK_IS_ENABLED = 5;
const TIME_INTERVAL_WHEN_STOCK_FALLBACK_IS_DISABLED = 30;

backgroundJob.registerJob({
    name: APP_BACKGROUND_JOBS.SALES_SYNC,
    handler: unsyncedSalesJobHandler,
    timeInMinutes: 5,
});

backgroundJob.registerJob({
    name: APP_BACKGROUND_JOBS.REGISTER_INFO_LOG,
    handler: logRegisterInfoJobHandler,
    timeInMinutes: 10,
});

backgroundJob.registerJob({
    name: APP_BACKGROUND_JOBS.SUBSCRIPTION,
    handler: subscriptionJobHandler,
    timeInMinutes: 60,
});

export function BackgroundJobManager() {
    const { featureFlags } = useFeatureFlagStore();
    const isFallbackEnabled =
        featureFlags?.[FEATURE_FLAGS.ENABLE_STOCK_TRACKING_FALLBACK] ?? false;

    const isNewCartArchitectureEnabled =
        !!featureFlags?.[FEATURE_FLAGS.ENABLE_NEW_CART_ARCHITECTURE];

    const branchId = useBusinessStore((state) => state.businessInfo.branchId);

    useEffect(() => {
        if (!branchId) return;
        backgroundJob.subscribe();

        return () => {
            backgroundJob.unsubscribe();
        };
    }, [branchId]);

    useEffect(() => {
        backgroundJob.registerJob({
            name: APP_BACKGROUND_JOBS.ITEM_STOCK_SYNC,
            handler: itemStockSyncJobHandler,
            timeInMinutes: isFallbackEnabled
                ? TIME_INTERVAL_WHEN_STOCK_FALLBACK_IS_ENABLED
                : TIME_INTERVAL_WHEN_STOCK_FALLBACK_IS_DISABLED,
        });

        return () => {
            backgroundJob.unRegisterJob(APP_BACKGROUND_JOBS.ITEM_STOCK_SYNC);
        };
    }, [isFallbackEnabled]);

    useEffect(() => {
        backgroundJob.registerJob({
            name: APP_BACKGROUND_JOBS.CART_SYNC,
            handler: isNewCartArchitectureEnabled
                ? syncPendingCartJobHandlerV2
                : savedCartJobHandler,
            timeInMinutes: 5,
        });

        if (isNewCartArchitectureEnabled) {
            backgroundJob.registerJob({
                name: APP_BACKGROUND_JOBS.CART_FETCH,
                handler: fetchCartsJobHandlerV2,
                timeInMinutes: 5,
            });
        }

        return () => {
            backgroundJob.unRegisterJob(APP_BACKGROUND_JOBS.CART_SYNC);
            backgroundJob.unRegisterJob(APP_BACKGROUND_JOBS.CART_FETCH);
        };
    }, [isNewCartArchitectureEnabled]);

    return null;
}

export { backgroundJob };
